import {
    AbstractControlOptions,
    AsyncValidatorFn,
    FormBuilder,
    ValidatorFn,
} from '@angular/forms';
import { Injectable } from '@angular/core';

import { ClientSharedUiCommonModule } from '../common.module';
import { LabeledFormControl } from '../labeled-form-control/labeled-form.control';

@Injectable({
    providedIn: ClientSharedUiCommonModule,
})
export class ExtendedFormBuilder extends FormBuilder {
    public lblControl(
        label: string,
        formState?: any,
        validatorOrOpts?:
            | ValidatorFn
            | ValidatorFn[]
            | AbstractControlOptions
            | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
        displayFn?: Function
    ) {
        return new LabeledFormControl(
            label,
            formState,
            validatorOrOpts,
            asyncValidator,
            displayFn
        );
    }
}
